// Navbar "version" tags identify which navbar experience fired a tracking event,
// so analysts can distinguish otherwise-identical clicks (e.g. the base "Contact Us"
// link vs. the phase 1 "Help" link) without relying solely on the Eppo assignment.
// This lets analysts retain historical data and dashboards while distinguishing
// experiences in "fix our foundations" (FOF) experiments.
export const NAVLINK_VERSIONS = {
  BASE: '2026-07',
  FOF_PHASE_1: '2026-07.fof-navbar-p1',
  FOF_PHASE_2A: '2026-11.fof-navbar-p2a',
  FOF_PHASE_2B: '2026-11.fof-navbar-p2b',
} as const;

// Central source of truth for AppBar navlink tracking values.
export const NAVLINK_TRACKING = {
  profile: {
    clicked: 'navlink.profile.clicked',
    hovered: 'navlink.profile.hovered',
    dropdownOpened: 'appbar-profile-menu-opened',
  },
  notifications: {
    clicked: 'navlink.notifications.clicked',
    hovered: 'navlink.notifications.hovered',
    dropdownOpened: 'appbar-notifications-opened',
  },
  orders: {
    text: 'Orders Button',
    clicked: 'navlink.orders.clicked',
    hovered: 'navlink.orders.hovered',
  },
  // `help` intentionally reuses the Contact Us text + Datadog action: Help replaced the
  // base navbar's Contact Us button, so they share one analytics identity.
  help: {
    text: 'Contact Us Button',
    version: NAVLINK_VERSIONS.FOF_PHASE_1,
    clicked: 'navlink.contact-us.clicked',
  },
  // The navbar draft cart dropdown. The `elementName`s are the `trackClick` names the dropdown has
  // always fired; analysts query them by name, so they must never be renamed. The `datadogAction`s
  // are their stable Datadog RUM twins. Bare `clicked` is the cart BUTTON, as for profile and
  // notifications — clicks inside the dropdown have their own names.
  cart: {
    clicked: 'navlink.cart.clicked',
    hovered: 'navlink.cart.hovered',
    dropdownOpened: 'appbar-cart-opened',
    card: {
      elementName: 'app-bar-draft-order-card',
      datadogAction: 'navlink.cart.card.clicked',
    },
    continueOrder: {
      elementName: 'app-bar-draft-order-continue-order-button',
      datadogAction: 'navlink.cart.continue-order.clicked',
    },
    delete: {
      elementName: 'draft-order-delete-order-button',
      datadogAction: 'navlink.cart.delete.clicked',
    },
    deleteConfirm: {
      elementName: 'draft-order-delete-cart-modal-confirm',
      datadogAction: 'navlink.cart.delete-confirm.clicked',
    },
    deleteClosed: {
      elementName: 'draft-order-delete-cart-modal-closed',
      datadogAction: 'navlink.cart.delete-modal.closed',
    },
    seeAll: {
      elementName: 'see-all-drafts-button',
      datadogAction: 'navlink.cart.see-all.clicked',
    },
  },
} as const;
